import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "sparbase_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 900);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, choice);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60] bg-card border border-volt/30 rounded-2xl p-4 shadow-[0_0_24px_rgba(0,0,0,0.6)]"
        >
          <div className="flex items-start gap-3">
            <div className="w-9 h-9 rounded-xl bg-volt/10 border border-volt/30 flex items-center justify-center shrink-0">
              <Cookie size={18} className="text-volt" />
            </div>
            <div className="flex-1">
              <p className="text-sm text-zinc-300 leading-relaxed">
                We use essential cookies to keep you signed in and run SparBase. See our{" "}
                <Link to="/privacy" className="text-volt underline">Privacy Policy</Link>.
              </p>
              <div className="flex gap-2 mt-3">
                <button
                  data-testid="cookie-accept"
                  onClick={() => decide("accepted")}
                  className="bg-volt text-black font-heading font-bold uppercase tracking-widest text-xs px-4 py-2 rounded-lg hover:bg-volt-hover transition-colors duration-200"
                >
                  Accept
                </button>
                <button
                  data-testid="cookie-essential"
                  onClick={() => decide("essential")}
                  className="border border-[#27272a] text-zinc-300 uppercase tracking-widest text-xs px-4 py-2 rounded-lg hover:border-volt hover:text-volt transition-colors duration-200"
                >
                  Essential only
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
